import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of, delay, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { deepSafeJsonParserHelper } from '../../helpers/deep-safe-json-parser.helper';
import { OrderTimeline, OrderTimelineEnvelope, OrderTimelineResponse } from './order-timeline-event.model';



@Injectable({ providedIn: 'root' })
export class OrderTimelineService {
  constructor(private readonly http: HttpClient) {}


  private readonly baseUrl = `${environment.backend.url}/api/vtex/orders/v1`

  getTimeline(orderId: string): Observable<OrderTimeline> {
    const url =
      `${this.baseUrl}/timeline/${encodeURIComponent(orderId)}`;

    return this.http.get<OrderTimelineResponse>(url).pipe(
      map(response => response.orderTimelineEvents)
    );
  }

  getFullTimeline(orderId: string): Observable<unknown> {
    const url =
      `${this.baseUrl}/full-timeline/${encodeURIComponent(orderId)}`;

    return this.http.get<unknown>(url);
  }

  getTimelineEnvelope(orderId: string): Observable<OrderTimelineEnvelope> {
    const url = `${this.baseUrl}/timeline/${encodeURIComponent(orderId)}`;
    return this.http.get<OrderTimelineEnvelope>(url);
  }




}
